/**
 * MUI Autocomplete renders popup/clear IconButtons without type="button".
 * Inside a <form>, those default to type="submit" and accidentally submit the form.
 */
export const markAutocompleteAdornmentButtons = (root: HTMLElement | null) => {
  if (!root) {
    return;
  }

  root
    .querySelectorAll<HTMLButtonElement>('button.MuiAutocomplete-popupIndicator, button.MuiAutocomplete-clearIndicator')
    .forEach((button) => {
      button.type = 'button';
    });
};
